import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import "@amzn/meridian-tokens/base/font/amazon-ember.css";
import {IntlProvider} from "react-intl";
import {getLocale, getMessages} from "./components/handler/LocaleHandler";
import App from "./components/app";
import ErrorBoundary from "./components/ErrorBoundary";
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en'
import ja from 'react-intl/locale-data/ja'
import it from 'react-intl/locale-data/it'
import fr from 'react-intl/locale-data/fr'
import es from 'react-intl/locale-data/es'
import de from 'react-intl/locale-data/de'
import ar from 'react-intl/locale-data/ar'
import {HashRouter} from "react-router-dom";

addLocaleData(en)
addLocaleData(ja)
addLocaleData(it)
addLocaleData(de)
addLocaleData(fr)
addLocaleData(es)
addLocaleData(ar)

ReactDOM.render((
    <IntlProvider locale={getLocale()} messages={getMessages()}>
        <HashRouter>
            <ErrorBoundary>
                <App/>
            </ErrorBoundary>
        </HashRouter>
    </IntlProvider>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


// WEBPACK FOOTER //
// ./src/index.js